// extracted by mini-css-extract-plugin
export default {"root":"SuccessMessageModal_root__68Chx","doneIcon":"SuccessMessageModal_doneIcon__7LIWA"};